import React from 'react';
import PropTypes from 'prop-types';
import { ErrorText, VisuallyHidden, ActivityCard } from '@web/atoms';
import { StyledFieldset, CardContainer } from './styles.js';

export const ActivityCardGroup = ({
  choices,
  value,
  name,
  legendText,
  onChange,
  onClick,
  disabled,
  direction = 'column',
  error,
}) => {
  return (
    <StyledFieldset>
      <VisuallyHidden>
        <legend>{legendText}</legend>
      </VisuallyHidden>
      <CardContainer direction={direction}>
        {choices.map(choice => {
          const checked = value === choice.value;

          return (
            <div key={choice.value}>
              <VisuallyHidden>
                <input
                  type="radio"
                  id={`${name}-${choice.value}`}
                  name={name}
                  value={choice.value}
                  checked={checked}
                  onChange={e => onChange(e.target.value)}
                  onClick={onClick}
                  disabled={disabled}
                />
              </VisuallyHidden>
              <ActivityCard
                label={`Select ${choice.name}`}
                title={choice.name}
                description={choice.description}
                img={choice.image}
                checked={checked}
                onChange={() => onChange(choice.value)}
                unavailable={disabled}
                unavailableText="This option is currently unavailable."
              />
            </div>
          );
        })}
      </CardContainer>
      {error && <ErrorText>{error}</ErrorText>}
    </StyledFieldset>
  );
};

ActivityCardGroup.displayName = 'ActivityCardGroup';
ActivityCardGroup.propTypes = {
  name: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }).isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  legendText: PropTypes.string.isRequired,
};
